module.exports = __webpack_public_path__ + "img/logo-dark.5d6de515.png";